<template>
  <div class="body" >
    <div class="container">
      <dashboard-side-nav/>
      <dashboard-v />
    </div>
  </div><!-- container -->
</template>

<script>
import DashboardSideNav from '@/components/Dashboard/SideNav.vue'
import DashboardV from '@/components/Dashboard/List.vue'
export default {
  name: 'App',
  components: {
    DashboardSideNav,
    DashboardV
  },
}
</script>
